import { createFileRoute } from "@tanstack/react-router";
import { QueueGroupForm } from "./-components/queue-group-form";

export const Route = createFileRoute("/_dashboard/queue-groups/new-group")({
  component: RouteComponent,
  loader: async () => ({
    crumb: "New group",
  }),
});

function RouteComponent() {
  return <QueueGroupForm queueGroup={null} isEdit={false} />;
}
